import React from "react";
import { FiFlag } from "react-icons/fi";
import MapAddressField from "./MapAddressField";
import { DropCard as Card, Label, I, FieldError, AirportPointRadio } from "./fields";

export default function DropSection({
  v,
  set,
  errors,
  readOnly,
  placeIssue,
  onModeChange,
  onPlaceTyping,
  onPlaceSelect,
}) {
  const mapField = (placeholder) => (
    <MapAddressField
      side="drop"
      v={v}
      city={v.city}
      readOnly={readOnly}
      placeIssue={placeIssue}
      onPlaceTyping={onPlaceTyping}
      onPlaceSelect={onPlaceSelect}
      placeholder={placeholder}
    />
  );

  return (
    <Card
      title="Drop Details"
      subtitle={v.dutyType === "OUTSTATION" ? "Where the trip ends. Search any city in India." : "Where the trip ends"}
      icon={<FiFlag className="w-5 h-5" />}
    >
      <div className="mb-3">
        <AirportPointRadio value={v.dropMode} onChange={(val)=> onModeChange("drop", val)} disabled={readOnly} />
      </div>

      {v.dropMode === "AIRPORT" ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div data-field="dropAirportName">
            <Label required>Airport Name</Label>
            <I value={v.dropAirportName} onChange={set("dropAirportName")} placeholder="e.g. IGI T3" readOnly={readOnly} invalid={!!errors.dropAirportName} />
            <FieldError msg={errors.dropAirportName} />
          </div>
          <div>
            <Label>Flight No. (optional)</Label>
            <I value={v.dropFlightNo} onChange={set("dropFlightNo")} placeholder="e.g. AI-456" readOnly={readOnly} />
          </div>
          <div className="md:col-span-2">
            {mapField("Search the airport or terminal on Google Maps")}
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div data-field="dropAddress">
            <Label required>Trip will Terminate At</Label>
            <I value={v.dropAddress} onChange={set("dropAddress")} placeholder="House / building, street, landmark" readOnly={readOnly} invalid={!!errors.dropAddress} />
            <FieldError msg={errors.dropAddress} />
          </div>
          <div>
            {mapField("Search Google address")}
          </div>
        </div>
      )}
    </Card>
  );
}
